import React, { useEffect } from 'react'
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client'
import { MatomoProvider, createInstance, useMatomo } from "@datapunt/matomo-tracker-react";
import { GraphQLURL } from '../Constants/AppData'
import introspectionQueryResultData from './fragmentTypes.json';
import DocumentViewWrapper from '../Components/DocumentView/DocumentViewWrapper'
import { Provider } from 'react-redux';
import createStore from '../../../core/store/createStore';
import InitialComponent from '../Components/InitialComponent/InitialComponent'
import RouterChooser from '../Components/RouterChooser/RouterChooser'
import EventHandler from '../Components/EventHandler/EventHandler'
import isElectron from 'is-electron'
import NetworkSensor from "./Sensors/NetworkSensor";
import AlertEventHandler from "./EventHandler/AlertEventHandler";
import { setContext } from "@apollo/client/link/context";
import AnalyticsEventHandler from "./EventHandler/AnalyticsEventHandler";

let electron;
let electronIsDev;
let webIsDev;
let DownloadEventHandler;

if ( isElectron () ) {
    electron = window.require ( 'electron' )
    electronIsDev = window.require ( 'electron-is-dev' );
    DownloadEventHandler = require('../../Download/Event/Handler/DownloadEventHandler').default;
} else {
    webIsDev = process.env.NODE_ENV === 'development';
}
const ipcRenderer = electron && electron.ipcRenderer;

const getIntrospectionQueryResultData = () => {
    const possibleTypes = {};
    const result = JSON.parse ( JSON.stringify ( introspectionQueryResultData ) );

    result.__schema.types.forEach ( supertype => {
        if ( supertype.possibleTypes ) {
            possibleTypes[supertype.name] =
                supertype.possibleTypes.map ( subtype => subtype.name )
        }
    } )

    return possibleTypes
}

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
};

const possibleTypes = getIntrospectionQueryResultData ();

const httpLink = createHttpLink ( {
    uri: `${ GraphQLURL }/graphql/`,
} );

const authLink = setContext ( ( _, { headers } ) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem ( 'token' );
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${ token }` : "",
        }
    }
} );

const graphqlClient = new ApolloClient ( {
    cache: new InMemoryCache ( {
        possibleTypes
    } ),
    link: authLink.concat ( httpLink ),
    defaultOptions: defaultOptions,
    connectToDevTools: webIsDev || electronIsDev,
} )

const store = createStore ();

let siteId;

// Enviroment variable or site host dependent siteId.

if ( !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ) {
    siteId = 28;

} else if ( process.env.REACT_APP_SITE_ID ) {
    siteId = process.env.REACT_APP_SITE_ID;

} else {
    const locationHost = window.location.host;

    switch ( locationHost ) {
        case "werfendocs.werfen.com":
            siteId = 27;
            break;
        case "werfendocsdemo.werfen.com":
            siteId = 28;
            break;
        case "werfendocstest.werfen.com":
            siteId = 70;
            break;
        case "docs.instrumentationlaboratory.com":
            siteId = 32;
            break;
        case "werfendocs.werfen.cn":
            siteId = 37;
            break;
        case "docs.leventon.es":
            siteId = 43;
            break;
        case "eemeaidocs.werfen.com":
            siteId = 48;
            break;
        default:
            siteId = 28;
    }
}

const matomoInstance = createInstance ( {
    urlBase: "https://wlpiwik01.werfen.com/piwik",
    siteId: siteId,
    linkTracking: false
} )

const TheApp = () => {
    const { enableLinkTracking } = useMatomo ()

    enableLinkTracking ();

    return (
        <>
            <EventHandler/>
            <AlertEventHandler/>
            { isElectron() && DownloadEventHandler && <DownloadEventHandler/> }
            <AnalyticsEventHandler/>
            { isElectron() && <NetworkSensor/> }
            {/*{ isElectron() && <ServerSensor/> }*/}
            <InitialComponent/>
            <DocumentViewWrapper/>
        </>
    )
}

const Root = () => {
    useEffect ( () => {
        if ( isElectron () ) {
            ipcRenderer.send ( 'createDatabase' );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <RouterChooser>
            <Provider store={ store }>
                <ApolloProvider client={ graphqlClient }>
                    <MatomoProvider value={ matomoInstance }>
                        <TheApp/>
                    </MatomoProvider>
                </ApolloProvider>
            </Provider>
        </RouterChooser>
    )

}

export default Root;

